import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-enterprise-application',
  standalone: false,
  templateUrl: './enterprise-application.component.html',
  styleUrls: ['./enterprise-application.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EnterpriseApplicationComponent { }
